import { wsActions, WsContainer } from 'ducks/websocket'
import { ProjectEditStateMsg } from 'elements/websocket/SocketStatusIcon'
import { useAdaActive } from 'layout/widgets/adaChat/useAdaActive'
import { useCallback, useEffect } from 'react'
import { useDispatch } from 'react-redux'

/**
 * Dummy component to initialize the websocket connection for the chat drawer.
 * Copied from the existing SocketDialog, this is probably inefficienty and should be simplified/fixed.
 */
export default function SocketInitForChatDrawer() {
  const dispatch = useDispatch()
  const { active: adaActive } = useAdaActive()

  const onMessage = useCallback((data: ProjectEditStateMsg, cont: WsContainer<ProjectEditStateMsg>) => {}, [])

  useEffect(() => {
    if (!adaActive) {
      return
    }
    dispatch(wsActions.addSubscriber<ProjectEditStateMsg>(onMessage))

    return () => {
      dispatch(wsActions.removeSubscriber<ProjectEditStateMsg>(onMessage))
    }
  }, [onMessage, adaActive])

  return null
}
